// Central role numbers, labels, and post-login landing paths.
export const ROLES = {
  SUPERADMIN: 100,
  CLUB_ADMIN: 110,
  CLUB_MANAGER: 101,
  CLUB_RECEPTIONIST: 102,
};

export const ROLE_LABELS = {
  100: 'Super Admin',
  110: 'Club Admin',
  101: 'Club Manager',
  102: 'Club Receptionist',
};

export function roleLabel(role) {
  const r = Number(role);
  return ROLE_LABELS[r] || (Number.isFinite(r) ? `Role ${r}` : '');
}

// The club roles (non-superadmin) operate inside a single fixed club.
export function isClubRole(role) {
  const r = Number(role);
  return r === ROLES.CLUB_ADMIN || r === ROLES.CLUB_MANAGER || r === ROLES.CLUB_RECEPTIONIST;
}

// Where each role lands right after login.
export function landingPathForRole(role, issuerId) {
  const r = Number(role);
  if (r === ROLES.SUPERADMIN) return '/ClubManagement';
  if (isClubRole(r)) {
    return (issuerId !== null && issuerId !== undefined && issuerId !== '')
      ? `/club/${issuerId}/home`
      : '/';
  }
  return '/';
}
